export var WidgetType = /*#__PURE__*/function (WidgetType) {
  WidgetType["Content"] = "Content";
  WidgetType["Dashboard"] = "Dashboard";
  return WidgetType;
}(WidgetType || {});